import React from 'react';

import PropTypes from 'prop-types';

import Line from './Line';
import styles from './TableSkeleton.module.scss';

const TableSkeleton = ({ lineHight, mb, num }) => {
  const renderItems = () => {
    const items = [];
    for (let index = 0; index < num; index += 1) {
      items.push(
        <Line
          key={Math.random()}
          style={{ height: lineHight, width: '100%' }}
          gradient={styles.gradient}
          className={`radius-4 ${mb}`}
        />
      );
    }
    return items;
  };
  return (
    <div>
      <div className='mt-3'>{renderItems()}</div>
    </div>
  );
};

TableSkeleton.propTypes = {
  lineHight: PropTypes.number,
  mb: PropTypes.string,
  num: PropTypes.number,
};

TableSkeleton.defaultProps = {
  lineHight: 32,
  mb: 'mb-3',
  num: 3,
};

export default TableSkeleton;
